import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useParams } from "react-router";

import { GqlSettingsObservationTypeCreateInput } from "~/__generated__";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import useSettingsObservationTypeCreateRoute_Create from "./api/useSettingsObservationTypeCreateRoute_Create";
import ObservationTypeCreateForm from "./components/ObservationTypeCreateForm";

export default function SettingsObservationTypeCreateRoute() {
    const { t } = useTranslation("observationType");
    const navigate = useNavigate();
    const { researchTypeId } = useParams();

    if (!researchTypeId) throw Error("no researchTypeId param in url");

    const { createObservationType, error } = useSettingsObservationTypeCreateRoute_Create();

    const handleSubmit = async (formData: GqlSettingsObservationTypeCreateInput) => {
        const createInput = {
            ...formData,
            researchTypeId,
        };

        const observationType = await createObservationType(createInput);

        if (observationType) {
            navigate(
                generatePath(`/admin/settings/researchType/:researchTypeId/observationType/:observationTypeId`, {
                    researchTypeId,
                    observationTypeId: observationType.id,
                }),
            );
        }
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("settingsObservationTypeCreateRoute.title")}>
                <ObservationTypeCreateForm onSubmit={handleSubmit} error={error} />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
